import CarousalComponent from './CarousalComponent';

export default CarousalComponent;
